import { setSameHeight } from '../utils/helpers';

export const SolutionBenefitsWidget = function () {
	this.selectors = {
		wrapper: jQuery('.nx_solution_benefits_widget'),
		popupItemsWrapper: jQuery(
			'.nx_solution_benefits_widget .benefits-popup'
		),
		popupItems: jQuery(
			'.nx_solution_benefits_widget .benefits-popup__carousel'
		),
		readMore: jQuery('.nx_solution_benefits_widget .benefits__item-button'),
	};

	this.state = {
		owl: null,
	};

	this.config = {
		owl: {
			center: true,
			items: 1,
			startPosition: 0,
			loop: true,
			stagePadding: 0,
			margin: 0,
			autoHeight: true,
			nav: true,
			navText: [
				`<img src="${AssetsPath.url}/images/sb-shevron-left.svg" alt="shevron-left">`,
				`<img src="${AssetsPath.url}/images/sb-shevron-right.svg" alt="shevron-right">`,
			],
			dots: false,
			autoplay: false,
			autoplayTimeout: 6000,
			smartSpeed: 1000,
			dragEndSpeed: 1000,
			autoplayHoverPause: false,
		},
	};

	this.init = () => {
		this.addEventListeners();
		setSameHeight('.nx_solution_benefits_widget .benefits__item');
	};

	this.addEventListeners = () => {
		this.selectors.readMore.on('click', this.readMoreClickHandler);

		window.addEventListener('resize', this.windowResizeHandler);
	};

	this.readMoreClickHandler = (event) => {
		const $target = jQuery(event.currentTarget);

		this.config.owl.startPosition =
			parseInt($target.data('item-number')) - 1;

		this.openPopup();
	};

	this.openPopup = () => {
		jQuery.magnificPopup.open({
			items: {
				src: this.selectors.popupItemsWrapper,
				type: 'inline',
			},
			callbacks: {
				open: this.popupOpenCallback,
				close: this.popupCloseCallback,
			},
		});
	};

	this.popupOpenCallback = () => {
		this.owlCreate();
		this.toggleBodyLock();
	};

	this.popupCloseCallback = () => {
		this.owlDestroy();
		this.toggleBodyLock();
	};

	this.owlCreate = () => {
		const $itemsWrapper = jQuery('.mfp-content .benefits-popup__carousel');
		if ($itemsWrapper.length < 1) {
			return;
		}

		const owl = this.state.owl;
		if (owl) {
			return;
		}

		this.state.owl = $itemsWrapper.owlCarousel(this.config.owl);
	};

	this.owlDestroy = () => {
		const owl = this.state.owl;
		if (!owl) {
			return;
		}

		owl.trigger('destroy.owl.carousel');
		this.state.owl = null;
	};

	this.toggleBodyLock = () => {
		document.body.classList.toggle('lock');
	};

	this.windowResizeHandler = () => {
		setSameHeight('.nx_solution_benefits_widget .benefits__item');
	};
};
